__webpack_require__.p = "/React-restaurant-app/";